// src/internal/i18n/defaultDictionary.ts
var defaultDictionary = {
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.loading": "Loading\u2026",
  "common.error": "Something went wrong",
  "common.retry": "Try again",
  "common.search": "Search",
  "common.empty": "No data",
  "common.required": "Required",
  "errorBoundary.title": "Page failed to render",
  "errorBoundary.subtitle": "sorry for the inconvenience",
  "errorBoundary.alertTitle": "Something went wrong",
  "errorBoundary.alertBody": "You can try reloading the page. If the problem persists, please let us know.",
  "errorBoundary.actionHome": "Go home",
  "errorBoundary.actionReload": "Try again",
  "pagination.prev": "Previous",
  "pagination.next": "Next",
  "pagination.perPage": "per page",
  "pagination.perPageAria": "Items per page",
  "pagination.nounOne": "item",
  "pagination.nounFew": "items",
  "pagination.nounMany": "items",
  "pagination.summary": "{count} {noun} \xB7 page {page}",
  "pagination.summaryWithTotal": "{count} {noun} \xB7 page {page} of {totalPages}",
  "pagination.range": "Showing {start}\u2013{end} of {total}",
  "pagination.rangeWithNoun": "Showing {start}\u2013{end} of {total} {noun}",
  "apiError.401": "Your session has expired. Please log in again.",
  "apiError.403": "You do not have permission to perform this action.",
  "apiError.404": "Record not found.",
  "apiError.server": "Server error. Please try again.",
  "apiError.generic": "Error {status}.",
  "apiError.unexpected": "Unexpected error.",
  "sidebar.navAria": "Main navigation",
  "sidebar.profileAria": "My profile",
  "sidebar.logout": "Log out",
  "sidebar.logoutAria": "Log out of the application",
  "topbar.menuOpenAria": "Open menu",
  "field.boolean.true": "Yes",
  "field.boolean.false": "No",
  "picker.date.placeholder": "DD.MM.YYYY",
  "picker.date.dialogLabel": "Choose date",
  "picker.date.clearLabel": "Clear date",
  "picker.date.openLabel": "Open calendar",
  "picker.date.invalidFormat": "Invalid date format (DD.MM.YYYY)",
  "picker.week.placeholder": "Choose week",
  "picker.week.dialogLabel": "Choose week",
  "picker.week.clearLabel": "Clear week",
  "picker.month.placeholder": "Choose month",
  "picker.month.dialogLabel": "Choose month",
  "picker.month.clearLabel": "Clear month",
  "picker.range.placeholder": "Choose date range",
  "picker.range.dialogLabel": "Choose date range",
  "picker.range.clearLabel": "Clear date range",
  "picker.time.placeholder": "HH:MM",
  "picker.time.dialogLabel": "Choose time",
  "picker.time.clearLabel": "Clear time",
  "picker.time.openLabel": "Open time picker",
  "picker.time.invalidFormat": "Invalid time format (HH:MM)",
  "picker.time.hours": "Hours",
  "picker.time.minutes": "Minutes",
  "picker.datetime.placeholder": "DD.MM.YYYY HH:MM",
  "picker.datetime.dialogLabel": "Choose date and time",
  "picker.datetime.clearLabel": "Clear date and time",
  "picker.datetime.openLabel": "Open date and time picker"
};

export { defaultDictionary };
//# sourceMappingURL=chunk-4DPTK2CR.js.map
//# sourceMappingURL=chunk-4DPTK2CR.js.map